export const Currency = ({ value }) => [
  parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }),
]

export default Currency
